import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import { ContentHeader, Loader } from '@components';
import { toast } from 'react-toastify';
import { getUserById, setUserSiteId } from '../../services/users';
import { getPortals } from '../../services/portal';
import moment from "moment/moment";

const ManageSites = () => {
  const [isLoading, setLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [selectSiteId, setselectSiteId] = useState([]);
  const [fillData, setFillData] = useState({
    id: '',
    name: '',
    email: ''
  });
  const navigate = useNavigate();
  const params = useParams();


  const handleSelect = (event: any) => {
    var value1 = event.target.value;
    var updatedList = [...selectSiteId];
    if (event.target.checked) {
      updatedList.push(parseInt(value1));
      setselectSiteId(updatedList);
      updateSiteId(parseInt(value1), 'add');
    } else {
      const index = updatedList.indexOf(parseInt(value1));
      if (index > -1) {
        updatedList.splice(index, 1);
      }
      setselectSiteId(updatedList);
      updateSiteId(parseInt(value1), 'remove');
    }
  };

  useEffect(() => {
    if (typeof params.id !== "undefined") {
      getPostalList();
      getUser(params.id);
    }
  }, [])

  const updateSiteId = (portal_id: number, action: string) => {
    setLoading(true);
    setUserSiteId(fillData.id, { portal_id: portal_id, action: action }).then(function (res: any) {
      const resp = res.data;
      setLoading(false);
      if (res.status === 200 && resp.Acknowledge == 1) {
      } else {
        toast.error('error to updating site');
      }
    }).catch(err => {
      setLoading(false);
      toast.error(err.response.data.FullMessage !== 'undefined' ? err.response.data.FullMessage : 'Internal Server Error!');
      navigate("/users");
    });
  }

  const getUser = (id: any) => {
    setLoading(true);
    getUserById(id).then(function (res: any) {
      const resp = res.data;
      setLoading(false);
      if (res.status === 200 && resp.Acknowledge == 1) {
        let respData = resp.user;
        setFillData({
          id: respData.id,
          name: respData.name,
          email: respData.email
        });
        if (respData.portals && respData.portals.length > 0) {
          setselectSiteId(respData.portals);
        }
      } else {
        navigate("/users");
      }
    }).catch(err => {
      setLoading(false);
      toast.error(err.response.data.FullMessage !== 'undefined' ? err.response.data.FullMessage : 'Internal Server Error!');
      navigate("/users");
    });
  };


  const getPostalList = (filter = "") => {
    setLoading(true);
    getPortals(filter).then(function (res) {
      const resp = res.data;
      if (resp.Acknowledge == 1 && resp.records) {
        let data: any = [];
        resp.records.map((val: any, i: any) => {
          data[i] = {
            id: val.id,
            name: val.name,
            image: val.image,
            created_at: val.created_at ? moment(val.created_at).format('MM/DD/YYYY') : '',
            updated_at: val.updated_at ? moment(val.updated_at).format('MM/DD/YYYY') : ''
          };
        });
        setListData(data);
        setLoading(false);
      }
    }).catch(err => {
      setLoading(false);
      return false;
    });
  };

  return (
    <>
      <ContentHeader title='Allow Portals' />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <form>
                <h5 className='mb-3 row'>
                  <div className="col-md-6">
                    Allow Portals Permission - {fillData.email}
                  </div>
                </h5>

                <div className='row'>
                  {
                    listData.length > 0 && listData.map((row: any, podidx: number) => (
                      <div className="col-3 mb-4">
                        <div className="card-deck">
                          <div className={`card portal-card${selectSiteId.includes(row.id) ? ' active' : ''}`}>
                            <img className="card-img-top p-2" src={`/img/portals/${row.image}`} alt={row.name} />
                            <div className="custom-control custom-switch per-site-checkbox">
                              <input type="checkbox"
                                className="custom-control-input"
                                id={`siteSwitch_${row.id}`}
                                name={`site_${row.id}`}
                                value={row.id}
                                checked={selectSiteId.includes(row.id) ? true : false}
                                onChange={(e) => handleSelect(e)}
                              />
                              <label className="custom-control-label" htmlFor={`siteSwitch_${row.id}`}></label>
                            </div>
                            <div className="card-footer card-f-per">
                              <h5 className="card-title card-t-per">{row.name}</h5>
                              {selectSiteId.includes(row.id) &&
                                <Link className="btn edit_btn float-right" to={{ pathname: `/users/manage-permission/${fillData.id}/${row.id}` }} title="Give Permission"><i className="nav-icon fa fa-user-lock"></i></Link>
                              }
                            </div>
                          </div>

                        </div>
                      </div>
                    ))
                  }
                </div>
              </form>
            </div>
            <Loader isLoading={isLoading} />
          </div>
        </div >
      </section >
    </>
  )
};

export default ManageSites;